import ClosetObject from './ClosetObject';
import { convertFromJni, convertToJni, TypeValue } from './jniValueConversion';
import { createModule as _createModule, ltjsModule } from './ltjsEnvironment';
export function createModule(moduleNamespace, typeIds, parent, moduleDefinition) {
    var module = _createModule(typeIds, parent);
    buildModule(module, moduleNamespace, moduleDefinition);
    return module;
}
function buildModule(module, moduleNamespace, moduleDefinition) {
    buildConstants(module, moduleDefinition[0]);
    buildProperties(module, moduleDefinition[1]);
    buildReadonlyProperties(module, moduleDefinition[2]);
    buildAccessors(module, moduleNamespace, moduleDefinition[3]);
    buildFunctions(module, moduleNamespace, moduleDefinition[4]);
    buildStaticFunctions(module, moduleNamespace, moduleDefinition[5]);
    buildOverloads(module, moduleDefinition[6]);
    buildStaticOverloads(module, moduleDefinition[7]);
}
function buildConstants(module, constants) {
    if (module && constants) {
        for (var _i = 0, _a = Object.entries(constants); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            module[key] = value;
        }
    }
}
function buildProperties(module, properties) {
    if (module && properties) {
        for (var _i = 0, _a = Object.entries(properties); _i < _a.length; _i++) {
            var _b = _a[_i], propertyName = _b[0], propType = _b[1];
            var getterName = createPrefixedName('get', propertyName);
            module.prototype[getterName] = buildPropertyGetter(getPropertyLTJSFunctionName(propType, 'get'), propertyName, convertFromJni(propType, true));
            var setterName = createPrefixedName('set', propertyName);
            module.prototype[setterName] = buildPropertySetter(getPropertyLTJSFunctionName(propType, 'set'), propertyName, convertToJni(propType));
        }
    }
}
function buildReadonlyProperties(module, readonlyProperties) {
    if (module && readonlyProperties) {
        for (var _i = 0, _a = Object.entries(readonlyProperties); _i < _a.length; _i++) {
            var _b = _a[_i], propertyName = _b[0], propType = _b[1];
            var getterName = createPrefixedName('get', propertyName);
            module.prototype[getterName] = buildPropertyGetter(getPropertyLTJSFunctionName(propType, 'get'), propertyName, convertFromJni(propType, true));
        }
    }
}
var propNameToJni = convertToJni(TypeValue.STRING);
function buildPropertyGetter(ltjsFuncName, propertyName, rvConverter) {
    return function () {
        var _a, _b;
        // Convert propertyName to JNI
        var propNameJni = propNameToJni.convert(propertyName);
        // Call property getter
        var rvJni = ltjsModule.module[ltjsFuncName](this._getValidClosetAddress(), propNameJni);
        // Convert return value from JNI
        var rv = rvConverter.convert(rvJni);
        // Cleanup JNI
        (_a = propNameToJni.cleanup) === null || _a === void 0 ? void 0 : _a.call(propNameToJni, propNameJni);
        (_b = rvConverter.cleanup) === null || _b === void 0 ? void 0 : _b.call(rvConverter, rvJni);
        return rv;
    };
}
function buildPropertySetter(ltjsFuncName, propertyName, valueConverter) {
    return function (value) {
        var _a, _b;
        // Convert value argument to JNI
        var valueJni = valueConverter.convert(value);
        // Convert propertyName to JNI
        var propNameJni = propNameToJni.convert(propertyName);
        // Call property setter
        ltjsModule.module[ltjsFuncName](this._getValidClosetAddress(), valueJni, propNameJni);
        // Cleanup JNI
        (_a = valueConverter.cleanup) === null || _a === void 0 ? void 0 : _a.call(valueConverter, valueJni);
        (_b = propNameToJni.cleanup) === null || _b === void 0 ? void 0 : _b.call(propNameToJni, propNameJni);
        return this;
    };
}
function buildAccessors(module, moduleNamespace, accessors) {
    if (module && accessors) {
        for (var _i = 0, _a = Object.entries(accessors); _i < _a.length; _i++) {
            var _b = _a[_i], accessorName = _b[0], accessorType = _b[1];
            var getterName = createPrefixedName('get', accessorName);
            module.prototype[getterName] = buildAccessorGetter("_ltjs_" + moduleNamespace + "_" + getterName, convertFromJni(accessorType));
            var setterName = createPrefixedName('set', accessorName);
            module.prototype[setterName] = buildAccessorSetter("_ltjs_" + moduleNamespace + "_" + setterName, convertToJni(accessorType));
        }
    }
}
function buildAccessorGetter(ltjsFuncName, rvConverter) {
    return function () {
        var _a;
        // Call getter
        var rvJni = ltjsModule.module[ltjsFuncName](this._getValidClosetAddress());
        // Convert return value from JNI
        var rv = rvConverter.convert(rvJni);
        // Cleanup JNI
        (_a = rvConverter.cleanup) === null || _a === void 0 ? void 0 : _a.call(rvConverter, rvJni);
        return rv;
    };
}
function buildAccessorSetter(ltjsFuncName, valueConverter) {
    return function (value) {
        var _a;
        // Convert value argument to JNI
        var valueJni = valueConverter.convert(value);
        // Call setter
        ltjsModule.module[ltjsFuncName](this._getValidClosetAddress(), valueJni);
        // Cleanup JNI
        (_a = valueConverter.cleanup) === null || _a === void 0 ? void 0 : _a.call(valueConverter, valueJni);
        return this;
    };
}
function buildFunctions(module, moduleNamespace, functions) {
    if (module && functions) {
        for (var _i = 0, _a = Object.entries(functions); _i < _a.length; _i++) {
            var _b = _a[_i], functionName = _b[0], functionSignature = _b[1];
            var rvType = functionSignature[0], argTypes = functionSignature.slice(1);
            module.prototype[functionName] = buildFunction("_ltjs_" + moduleNamespace + createUnderscoreName(functionName), rvType, convertFromJni(rvType), argTypes.map(convertToJni));
        }
    }
}
function buildFunction(ltjsFuncName, rvType, rvConverter, argConverters) {
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Convert arguments to JNI
        var argJniValues = argConverters.map(function (converter, index) { return converter.convert(args[index]); });
        // Call function
        var rvJni = ltjsModule.module[ltjsFuncName].apply(null, [this._getValidClosetAddress()].concat(argJniValues));
        // Convert return value from JNI
        // VOID return type is a special case and 'this' is returned.
        var rv = rvType === TypeValue.VOID ? this : rvConverter.convert(rvJni);
        // Cleanup JNI
        (_a = rvConverter.cleanup) === null || _a === void 0 ? void 0 : _a.call(rvConverter, rvJni);
        argConverters.forEach(function (converter, index) { var _a; return (_a = converter.cleanup) === null || _a === void 0 ? void 0 : _a.call(converter, argJniValues[index]); });
        return rv;
    };
}
function buildStaticFunctions(module, moduleNamespace, functions) {
    if (module && functions) {
        for (var _i = 0, _a = Object.entries(functions); _i < _a.length; _i++) {
            var _b = _a[_i], functionName = _b[0], functionSignature = _b[1];
            var rvType = functionSignature[0], argTypes = functionSignature.slice(1);
            module[functionName] = buildStaticFunction("_ltjs_" + moduleNamespace + createUnderscoreName(functionName), convertFromJni(rvType), argTypes.map(convertToJni));
        }
    }
}
function buildStaticFunction(ltjsFuncName, rvConverter, argConverters) {
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Convert arguments to JNI
        var argJniValues = argConverters.map(function (converter, index) { return converter.convert(args[index]); });
        // Call function
        var rvJni = ltjsModule.module[ltjsFuncName].apply(null, argJniValues);
        // Convert return value from JNI
        var rv = rvConverter.convert(rvJni);
        // Cleanup JNI
        (_a = rvConverter.cleanup) === null || _a === void 0 ? void 0 : _a.call(rvConverter, rvJni);
        argConverters.forEach(function (converter, index) { var _a; return (_a = converter.cleanup) === null || _a === void 0 ? void 0 : _a.call(converter, argJniValues[index]); });
        return rv;
    };
}
function buildOverloads(module, overloads) {
    if (module && overloads) {
        for (var _i = 0, overloads_1 = overloads; _i < overloads_1.length; _i++) {
            var funcName = overloads_1[_i];
            module.prototype[funcName] = buildOverloadedFunction(createUnderscoreName(funcName));
        }
    }
}
function buildOverloadedFunction(functionName) {
    return function () {
        return ClosetObject.callOverloadedFunction(this, functionName, Array.prototype.slice.call(arguments));
    };
}
function buildStaticOverloads(module, overloads) {
    if (module && overloads) {
        for (var _i = 0, overloads_2 = overloads; _i < overloads_2.length; _i++) {
            var funcName = overloads_2[_i];
            module[funcName] = buildOverloadedStaticFunction(module, createUnderscoreName(funcName));
        }
    }
}
function buildOverloadedStaticFunction(module, functionName) {
    return function () {
        return ClosetObject.callOverloadedFunction(module, functionName, Array.prototype.slice.call(arguments));
    };
}
function createPrefixedName(prefix, name) {
    return "" + prefix + name.charAt(0).toUpperCase() + name.substring(1);
}
function createUnderscoreName(name) {
    return name.charAt(0) === '_' ? name : "_" + name;
}
var ltjsFunctionTypeName = [];
// VOID, POINT, RECTANGLE, SIZE properties not supported
ltjsFunctionTypeName[TypeValue.WRAPPER] = 'Wrappable';
ltjsFunctionTypeName[TypeValue.BOOLEAN] = 'Boolean';
ltjsFunctionTypeName[TypeValue.UNSIGNED] = 'Unsigned';
ltjsFunctionTypeName[TypeValue.INT] = 'Int';
ltjsFunctionTypeName[TypeValue.FLOAT] = 'Float';
ltjsFunctionTypeName[TypeValue.DOUBLE] = 'Double';
ltjsFunctionTypeName[TypeValue.STRING] = 'String';
ltjsFunctionTypeName[TypeValue.SASDATE] = 'SASDate';
ltjsFunctionTypeName[TypeValue.SASDATETIME] = 'SASDatetime';
ltjsFunctionTypeName[TypeValue.SASCOLOR] = 'SASColor';
function getPropertyLTJSFunctionName(type, getOrSet) {
    if (Array.isArray(type)) {
        return "_ltjs_commons_Closet_" + getOrSet + ltjsFunctionTypeName[type[0]] + "VectorProperty";
    }
    else {
        return "_ltjs_commons_Closet_" + getOrSet + ltjsFunctionTypeName[type] + "Property";
    }
}
